import ReactEChartsCore from 'echarts-for-react/lib/core';
import * as echarts from 'echarts/core';
import { BarChart, LineChart, PieChart, GaugeChart } from 'echarts/charts';

import {
  GridComponent,
  LegendComponent,
  TooltipComponent,
  TitleComponent,
} from 'echarts/components';
import { SVGRenderer } from 'echarts/renderers';
import { DivisionsFormattedItemType } from '@type/dashboard';
import { memo, useCallback } from 'react';
import { colorPalette } from '../options';
import { useCustomParams } from '@hooks/useCustomParams';

echarts.use([
  TitleComponent,
  TooltipComponent,
  GridComponent,
  LegendComponent,
  BarChart,
  LineChart,
  PieChart,
  GaugeChart,
  SVGRenderer,
]);

const loadingOptions = (colorIndex: number | undefined | null) => {
  return {
    text: '',
    zlevel: 0,
    lineWidth: 5,
    color: {
      type: 'linear',
      x: 0,
      y: 0,
      x2: 0,
      y2: 1,
      colorStops: [
        {
          offset: 0,
          color: colorIndex ? colorPalette[colorIndex - 2][0] : '#DECBA4',
        },
        {
          offset: 1,
          color: colorIndex ? colorPalette[colorIndex - 2][1] : '#DECBA4',
        },
      ],
      global: false,
    },
    showSpinner: true,
    spinnerRadius: 20,
    maskColor: 'rgba(255, 255, 255, 0.8',
  };
};

interface ReactEChartsComponentPropsType {
  option: any;
  handleQuery: (
    divisionId: number,
    asonId: number,
    election_schedule_id: string,
  ) => void;
  divisionData?: DivisionsFormattedItemType | undefined;
  theme?: string;
  notMerge?: boolean;
  lazyUpdate?: boolean;
  isLoading?: boolean;
  minWidth?: string;
  colorIndex?: number | undefined | null;
}

export const ReactEChartsComponent = memo(
  ({
    option,
    theme = '',
    handleQuery,
    divisionData,
    notMerge = false,
    lazyUpdate = true,
    isLoading = false,
    colorIndex,
    minWidth,
  }: ReactEChartsComponentPropsType) => {
    const { searchParams } = useCustomParams();

    const onChartClick = (param: any) => {
      if (
        divisionData?.election_setting[param?.dataIndex] &&
        divisionData?.id
      ) {
        handleQuery(
          divisionData.id,
          divisionData.election_setting[param?.dataIndex].id,
          searchParams.get('election_schedule_id') || '',
        );
      }
    };

    const onChartClickCb = useCallback(onChartClick, [divisionData]);

    return (
      <>
        <ReactEChartsCore
          theme={theme}
          option={option}
          echarts={echarts}
          notMerge={notMerge}
          lazyUpdate={lazyUpdate}
          showLoading={isLoading}
          style={{
            height: '100%',
            minWidth: minWidth,
            maxWidth: '100%',
          }}
          loadingOption={loadingOptions(colorIndex)}
          onEvents={{
            click: onChartClickCb,
          }}
        />
      </>
    );
  },
);
